(function ($) {
    'use strict';

    var SignpostModule = {
        init: function () {
            this.$questionContainers = $('.js-question-container');
            this.$resultsContainer = $('.js-results-container');
            this.selectedAnswers = {};
            this.currentQuestion = 1;

            // Hide all questions except first
            this.$questionContainers.not(':first').hide();

            // Create spinner
            this.createSpinner();

            // Bind events
            this.bindEvents();
        },

        bindEvents: function () {
            var self = this;

            // Answer button clicks
            $(document).on('click', '.js-answer-btn', function () {
                var $btn = $(this);
                self.handleAnswerSelection($btn);
            });

            // Reset button clicks
            $(document).on('click', '.js-reset-btn', function (e) {
                e.preventDefault();
                self.resetModule();
            });
        },

        handleAnswerSelection: function ($btn) {
            var questionId = $btn.data('question-id');
            var answer = $btn.data('answer');

            // Store answer
            this.selectedAnswers[questionId] = answer;

            if (this.currentQuestion === 1) {
                // Show second question
                this.$questionContainers.eq(0).hide();
                this.$questionContainers.eq(1).show();
                this.currentQuestion = 2;
            } else {
                // Submit answers
                this.submitAnswers();
            }
        },

        submitAnswers: function () {
            var self = this;

            // Show spinner
            $('.js-spinner').fadeIn(200);

            // Create heading text from selected answers
            var selectedAnswersText = Object.values(this.selectedAnswers).join(' with ');

            // Get user's answers for matching
            var tag1 = this.selectedAnswers[1] || '';
            var tag2 = this.selectedAnswers[2] || '';

            $.ajax({
                url: '/umbraco/api/signpostapi/search',
                type: 'POST',
                contentType: 'application/json',
                data: JSON.stringify(this.selectedAnswers),
                success: function (results) {
                    var $resultsContainer = self.$resultsContainer;
                    var $resultsList = $resultsContainer.find('.js-results-list');
                    var $template = $resultsContainer.find('.js-result-template');
                    var $resultsGridSection = $resultsContainer.find('.m-signpost__results-grid-section');

                    // Update the results heading
                    $resultsContainer.find('.js-results-heading').text(selectedAnswersText);

                    // Hide all result messages first
                    $resultsContainer.find('.js-result-message').hide();

                    // Find and show matching result message if exists
                    $resultsContainer.find('.js-result-message').each(function () {
                        var $message = $(this);
                        var messageTag1 = $message.data('tag-1');
                        var messageTag2 = $message.data('tag-2');

                        // Debug the tag matching
                        console.log('Comparing tags:', {
                            'selected tag1': tag1,
                            'message tag1': messageTag1,
                            'selected tag2': tag2,
                            'message tag2': messageTag2
                        });

                        // Extract individual tags from combined string if needed
                        if (tag1.indexOf(' with ') > -1) {
                            var parts = tag1.split(' with ');
                            tag1 = parts[0];
                            if (!tag2) tag2 = parts[1];
                        }

                        // Case-insensitive comparison for both tags
                        if (messageTag1.toLowerCase() === tag1.toLowerCase() &&
                            messageTag2.toLowerCase() === tag2.toLowerCase()) {
                            var customMessage = $message.data('result-message');
                            $message.text(customMessage).show();
                        }
                    });

                    // Clear previous results
                    $resultsList.empty();

                    if (results && results.length > 0) {
                        // Hide no results message and show results grid section
                        $resultsContainer.find('.js-no-results').hide();
                        $resultsGridSection.show();

                        // Create result items
                        results.forEach(function (result) {
                            var $newResult = $template.clone()
                                .removeAttr('style')
                                .removeClass('js-result-template');

                            $newResult.find('.js-result-title').text(result.Title);
                            $newResult.find('.js-result-description').html(result.Description);

                            // Handle image
                            var $image = $newResult.find('.js-result-image');
                            if (result.Image) {
                                $image.attr({
                                    'src': result.Image,
                                    'alt': result.Title
                                }).show();
                            }

                            $newResult.find('.js-result-link').attr('href', result.Url);
                            $resultsList.append($newResult);
                        });
                    } else {
                        // Show no results message and hide results grid section
                        $resultsContainer.find('.js-no-results').show();
                        $resultsGridSection.hide();
                    }

                    // Hide spinner
                    $('.js-spinner').fadeOut(200);

                    // Hide original heading and intro
                    $('.m-signpost__heading').not('.js-results-heading').parent().hide();

                    // Hide questions
                    self.$questionContainers.hide();

                    // Show results
                    $resultsContainer.fadeIn(300);
                },
                error: function (xhr, status, error) {
                    $('.js-spinner').fadeOut(200);
                    console.error('Error:', error);
                    var $resultsContainer = self.$resultsContainer;
                    $resultsContainer.find('.js-no-results')
                        .show()
                        .find('p')
                        .text('Error loading results. Please try again.');
                    $resultsContainer.find('.m-signpost__results-grid-section').hide();
                    $resultsContainer.fadeIn(300);
                }
            });
        },

        resetModule: function () {
            // Reset state
            this.selectedAnswers = {};
            this.currentQuestion = 1;

            // Hide results and spinner
            this.$resultsContainer.hide();
            $('.js-spinner').hide();

            // Show original heading and intro
            $('.m-signpost__heading').not('.js-results-heading').parent().show();

            // Show first question
            this.$questionContainers.hide();
            this.$questionContainers.first().show();
        },

        createSpinner: function () {
            // Only create if it doesn't exist
            if (!$('.js-spinner').length) {
                // Add spinner styles
                if (!$('#spinner-style').length) {
                    $('<style>')
                        .attr('id', 'spinner-style')
                        .text('@keyframes spin { 0% { transform: rotate(0deg); } 100% { transform: rotate(360deg); } }')
                        .appendTo('head');
                }

                // Create spinner elements
                $('<div>', {
                    class: 'js-spinner',
                    css: {
                        display: 'none',
                        position: 'fixed',
                        top: 0,
                        left: 0,
                        width: '100%',
                        height: '100%',
                        background: 'rgba(255, 255, 255, 0.8)',
                        zIndex: 1000
                    }
                }).append(
                    $('<div>', {
                        css: {
                            position: 'absolute',
                            top: '50%',
                            left: '50%',
                            width: '50px',
                            height: '50px',
                            marginLeft: '-25px',
                            marginTop: '-25px',
                            border: '5px solid #f3f3f3',
                            borderTop: '5px solid #3498db',
                            borderRadius: '50%',
                            animation: 'spin 1s linear infinite'
                        }
                    })
                ).appendTo('body');
            }
        }
    };

    // Initialize on document ready
    $(function () {
        SignpostModule.init();
    });

})(jQuery);